module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAABIUlEQVR4AXzSSy6EURCG4e42QZgQE8FCSNDYhrjMDURiE2INLhMbcEvcbYBOhKkFsIb2fCf6RIfo1Juqv+p8qVN1utXtdj9xjeHGPz/1Kbxgq+XcDpZxJjHI/zL5ack7TOKx1Ww2DwUbWESEQ3w1gikftxjDkvOddGoIIlxLEucOlo58OtzL9QTP4kYRJSA85teRjqcEvQ7jcivqHb5YFeVL4YhfxSzeMYq2/BNfrU/0nX3gPzCAV7yhz/pErjSjeoMR7KKNS/kyo7hYFSlkhggmVLKlPT7LyYwX6lVYRBLZUtaaoTND2ZJZfi4nWy3PkX9ET5AOVaBLMcIsJ+9Yr5pOV6q9DnWtctUI846bEvPYjmhfsKBQriT+09QPFOZw8gUAAP//bjxgzAAAAAZJREFUAwA5wWv7B0q5ygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/yimou/gb.png
// module id = OHfa
// module chunks = 1